const gifTransitionCollection = [
  "https://media.giphy.com/media/r7yDTMHecleQo/giphy.gif",
  "https://media.giphy.com/media/WFGW9xik06wtG/giphy.gif",
  "https://media.giphy.com/media/bm8t2jTnNbCIEGQIXf/giphy.gif",
];

function randomizer(min, max) {
  return Math.floor(Math.random() * (max + 1)) + min;
}

const getRandomItemFromCollection = (collections) => {
  const getRandomIndex = randomizer(0, collections.length - 1);

  return collections[getRandomIndex];
};

export const getRandomTransitionGif = () =>
  getRandomItemFromCollection(gifTransitionCollection);
